import { render, staticRenderFns } from "./KYC.vue?vue&type=template&id=ae24d5f2&scoped=true&"
import script from "./KYC.vue?vue&type=script&lang=js&"
export * from "./KYC.vue?vue&type=script&lang=js&"
import style0 from "./KYC.vue?vue&type=style&index=0&id=ae24d5f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae24d5f2",
  null
  
)

export default component.exports